import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { COMPANY } from '../data/seedData';

export default function NotFoundPage() {
  return (
    <>
      <SeoHead
        title="404 - Siden kan desværre ikke findes - RB Glasfiber A/S"
        description="Siden kan desværre ikke findes. Gå til forsiden eller kontakt RB Glasfiber A/S."
      />

      <section className="pt-36 pb-20 min-h-[70vh] flex items-center justify-center bg-slate-50">
        <div className="max-w-xl mx-auto px-4 text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-[#1e9457]/10 text-[#1e9457] text-3xl font-mono font-bold border border-[#1e9457]/30">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 uppercase tracking-tight">
            Siden kan desværre ikke findes
          </h1>

          <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
            Vi beklager, men den side, du leder efter, findes ikke eller er blevet flyttet.
          </p>

          <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm text-left text-sm text-slate-600 space-y-2">
            <div className="font-semibold text-slate-900">Det kan skyldes:</div>
            <ul className="list-disc list-inside space-y-1 text-slate-600 text-xs sm:text-sm">
              <li>Du har indtastet webadressen forkert</li>
              <li>Siden er flyttet eller slettet</li>
            </ul>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
            <Link
              to="/"
              className="px-6 py-3 rounded bg-[#1e9457] hover:bg-[#15703f] text-white font-bold uppercase tracking-wider text-xs shadow transition-colors"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="px-6 py-3 rounded bg-slate-900 hover:bg-slate-800 text-white font-bold uppercase tracking-wider text-xs shadow transition-colors"
            >
              Kontakt os
            </Link>
          </div>

          <div className="pt-4 text-xs text-slate-500">
            Brug for direkte hjælp? Ring på{' '}
            <a href={`tel:${COMPANY.phoneRaw}`} className="font-bold text-slate-900 underline whitespace-nowrap">
              {COMPANY.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
